{
  "title": "Demandes de créneaux",
  "description": "Examinez les demandes de créneaux des clients et ouvrez des plages lorsque vous pouvez les accueillir",
  "searchPlaceholder": "Rechercher des demandes de créneaux...",
  "emptyTitle": "Aucune demande de créneau",
  "emptyDescription": "Lorsque des clients demandent des horaires indisponibles, leurs demandes apparaîtront ici.",
  "approve": "Approuver",
  "decline": "Refuser",
  "columns": {
    "customer": "Client",
    "service": "Service",
    "provider": "Prestataire",
    "date": "Date",
    "time": "Heure",
    "status": "Statut",
    "created": "Créé"
  },
  "dialog": {
    "approveTitle": "Approuver la demande d'horaire",
    "rejectTitle": "Refuser la demande d'horaire",
    "description": "{{customer}} a demandé le {{date}} à {{time}} pour {{service}}.",
    "customerFallback": "Client",
    "serviceFallback": "un service",
    "oneOffTitle": "Ponctuel (cette date uniquement)",
    "oneOffDescription": "Ouvre le créneau uniquement pour la date demandée.",
    "recurringTitle": "Récurrent (chaque semaine)",
    "recurringDescription": "Ajoute cet horaire au planning hebdomadaire du prestataire.",
    "rejectReasonLabel": "Motif (facultatif)",
    "rejectReasonPlaceholder": "Indiquez au client pourquoi cet horaire n'est pas disponible",
    "customerNote": "Note du client : {{note}}",
    "approveSuccess": "Créneau ouvert — le client sera notifié pour réserver",
    "rejectSuccess": "Demande refusée",
    "actionFailed": "Échec de l'action",
    "approveConfirm": "Approuver et ouvrir le créneau",
    "rejectConfirm": "Refuser la demande"
  }
}
